<template>
  <nx-button
    v-bind="$attrs"
    @click="click"
    :type="type"
    :size="size"
    :lineColor="lineColor"
    :faceColor="faceColor"
    :textColor="textColor"
    :style="{
      '--color': color
    }"
    :class="[useColor ? 'color' : '']"
  >
    <slot></slot>
  </nx-button>
</template>

<script>
import { create } from '../../utils'

// 文档地址： https://vos-ui.vmic.xyz/components/button.html

export default create({
  name: 'button',

  props: {
    /*********************** 整体封装 vos 组件属性 使其适配商城规范 ***********************/
    // 商城 按钮类型 默认是 primary
    type: {
      type: [String],
      default: 'primary',
    },
    /**
     * 商城 按钮尺寸 默认是 normal
     * large: 按钮高度 138px 宽度默认100%
     * normal: 按钮高度 138px 宽度自适应
     * medium: 按钮高度 96px 宽度自适应
     * small: 按钮高度 72px 宽度自适应
     */
    size: {
      type: [String],
      default: 'normal',
    },
    // 商城 线性按钮边框与文字的颜色 默认是 #f10313
    lineColor: {
      type: [String],
      default: '#f10313'
    },
    // 商城 面性按钮背景色 默认是 #f10313
    faceColor: {
      type: [String],
      default: '#f10313'
    },
    // 商城 面性按钮文字颜色 默认是 #fff
    textColor: {
      type: [String],
      default: '#fff'
    },
    /*********************** 整体封装 vos 组件属性 使其适配商城规范 ***********************/

    // 自定义按钮内文字颜色 不设置则采用 vos 默认颜色
    color: {
      type: [String],
      default: ''
    }
  },

  computed: {
    // 是否让color 属性生效，如果设置 color 值 就生效，避免属性默认值覆盖vos默认颜色
    useColor() {
      if (this.color === '') {
        return false
      } else return true
    }
  },

  methods: {
    click() {
      this.$emit('click')
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
